<template>
	<div class="SocialmediaCronWorksGroupItem">
		<div class="logo">
			<img :src="getBrand.logo" alt="">
		</div>
		<div class="customer-name">{{getBrand.brand_name}}</div>
		<div class="work-share-time">{{item.time}}</div>
		<div class="work-text">{{item.text}}</div>
		<div class="work-tags">
			<span class="tag" v-for="(tag,tagIndex) in item.tags" :key="tagIndex">{{tag}}</span>
		</div>
		<div class="modules">

			<div class="module" v-if="item.platforms.instagram_story.items.length">
				<div class="slot media">
					<img :src="item.platforms.instagram_story.items[0].thumbnail" alt="">
					<span class="item-count">{{item.platforms.instagram_story.items.length}}</span>
				</div>
				<div class="slot text">Instagram Story</div>
				<div class="slot status">
					<v-icon v-if="item.platforms.instagram_story.task">access_time</v-icon>
					<v-icon v-if="!item.platforms.instagram_story.task" color="success">check_circle</v-icon>
				</div>
			</div>
			<div class="module" v-if="item.platforms.instagram_post.items.length">
				<div class="slot media">
					<img :src="item.platforms.instagram_post.items[0].thumbnail" alt="">
					<span class="item-count">{{item.platforms.instagram_post.items.length}}</span>
				</div>
				<div class="slot text">Instagram Post</div>
				<div class="slot status">
					<v-icon v-if="item.platforms.instagram_post.task">access_time</v-icon>
					<v-icon v-if="!item.platforms.instagram_post.task" color="success">check_circle</v-icon>
				</div>
			</div>

		</div>
		<div class="functions">
			<v-btn round small color="success" dark @click="doEditMe()">Düzenle</v-btn>
		</div>
	</div>
</template>

<script>
export default {
	name : "SocialmediaCronWorksGroupItem",
	props : ["brands","item"],
	methods : {
		doEditMe(){
			this.$emit("editItem",this.item.id);
		}
	},
	computed : {
		getBrand(){
			if(this.item){
				for(var i in this.brands){
					if(this.item.brand_id == this.brands[i].id){
						return this.brands[i]
					}
				}
			}
			return {
				id : "",
				brand_name : "", 
				logo : "", 
			}
		}
	}
}
</script>


<style lang="less">
	.SocialmediaCronWorksGroupItem {
		min-height: 50px;
		margin-top: 15px;
		position: relative;
		padding-top: 50px;
		border: 2px solid #ccc;

		.logo {
			width: 40px;
			height: 40px;
			border-radius: 50%;
			background: #ccc;
			position: absolute;
			left: 5px;
			top: 5px;

			img {
				width: 40px;
				height: 40px;
				-o-object-fit: cover;
				object-fit: cover;
				border-radius: 50%;
			}
		}

		.customer-name {
			position: absolute;
			left: 55px;
			top: 5px;
		}

		.work-share-time {
			position: absolute;
			right: 5px;
			top: 5px;
			font-size: 11px;
			color: #666;
		}

		.work-text {
			position: absolute;
			left: 55px;
			top: 25px;
			right: 5px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			color: #888
		}

		.work-tags {
			padding: 0 3px 3px 3px;
			width: calc(~"100% - 10px");
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;

			.tag {
				background: #868686;
				margin-right: 3px;
				padding: 0 3px;
				color: #fff;
				font-size: 10px;
				display: inline-block;
			}
		}

		.modules {
			border-top: 2px dashed #ccc;

			.module {
				border: 1px solid #ddd;
				margin: 3px;
				display: -webkit-box;
				display: -ms-flexbox;
				display: flex;

				.slot {
					&.media {
						width: 36px;
						height: 36px;
						background: #303030;
						position: relative;

						img {
							width: 100%;
							height: 100%;
							-o-object-fit: cover;
							object-fit: cover;
						}

						.item-count {
							position: absolute;
							right: -6px;
							top: -6px;
							background-color: rgb(30, 138, 62);
							color: #fff;
							width: 16px;
							height: 16px;
							border-radius: 50%;
							text-align: center;
							line-height: 16px;
							font-size: 10px;

						}
					}

					&.text {
						padding-left: 5px;
						line-height: 36px;
						-webkit-box-flex: 1;
						-ms-flex: 1;
						flex: 1;
					}

					&.status {
						line-height: 36px;
						padding-right: 5px;

						i {
							display: block;
							padding: 0;
							margin: 0;
							line-height: 36px;
							color: inherit;
						}
					}
				}
			}
		}

		.functions {
			text-align: center;
			opacity: 0; 
			transition: all .4s;
			max-height: 0;
			overflow: hidden;
		}

		&:hover {
			.functions {
				opacity: 1;
				max-height: 50px;
			}
		}
	}
</style>